import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoNicknameChangeLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoNicknameChangeLogListResponse
  from '../../models/src/model/LogControllerDtoNicknameChangeLogListResponse';
import { NICKNAME_LOG_LIST_REQUEST } from '../../constants/log/nicknameTransactionLogConstants';

const api = new PerplayLogApi(config.API_CLIENT);

function* nicknameTransactionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNicknameChangeLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogNicknameChangeLogListPost({ logControllerDtoNicknameChangeLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNicknameChangeLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nicknameTransactionLogRootSaga() {
  yield all([
    takeEvery(NICKNAME_LOG_LIST_REQUEST, nicknameTransactionLogListRequestSaga),
  ]);
}

const nicknameTransactionLogSagas = [
  fork(nicknameTransactionLogRootSaga),
]

export default nicknameTransactionLogSagas;
